export default {"src":"/_next/static/media/fr.1fa43838.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};